import React, { useState, createContext, useContext } from 'react';
import { Dropdown as Bs5Dropdown } from 'react-bootstrap5';
import { IconCaretLeft, IconCaretRight } from './icons';
import './Dropdown.css';

const Item = Bs5Dropdown.Item;
const Menu = Bs5Dropdown.Menu;
const Divider = Bs5Dropdown.Divider;

// provides positioning information to the submenu
const ContextMenuPosition = createContext({ horizontal: 'right', vertical: 'bottom' });

const ContextMenu = ({ x, y, show, children }) => {
  if (!show) return null;

  const positioning = {};
  const windowWidth = document.body.clientWidth;
  const windowHeight = document.documentElement.clientHeight;

  // if the menu is too close to the right edge, set position of right side
  if (x > windowWidth * 0.6) {
    positioning.right = windowWidth - x;
  } else {
    positioning.left = x;
  }

  // if the menu is too close to the bottom, set position of bottom
  if (y > windowHeight * 0.6) {
    positioning.bottom = windowHeight - y;
  } else {
    positioning.top = y;
  }

  const style = {
    position: 'absolute',
    display: 'block',
    maxWidth: 'fit-content',
    overflowX: 'inherit',
    overflowY: 'inherit',
    zIndex: 9999,
    ...positioning
  };

  const subMenuPositioning = {
    horizontal: positioning.left ? 'left' : 'right',
    vertical: positioning.top ? 'top' : 'bottom'
  };

  return (
    <ContextMenuPosition.Provider value={subMenuPositioning}>
      <Menu show style={style}>
        {children}
      </Menu>
    </ContextMenuPosition.Provider>
  );
};

const SubMenu = ({ title, Icon, children }) => {
  const { horizontal } = useContext(ContextMenuPosition);
  const [show, setShow] = useState(false);

  const caret = horizontal === 'left' ? <IconCaretRight /> : <IconCaretLeft />;
  const horizontalClassName = horizontal === 'left' ? 'left' : 'right';
  let menuTitle = [Icon && <Icon />, ' ', title, ' ', caret];
  if (horizontal === 'right') menuTitle.reverse();

  return (
    <Item className="dropdown-submenu" onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
      <a tabIndex="-1">{menuTitle}</a>
      {show && (
        <Menu show className={horizontalClassName} style={{ display: 'block' }}>
          {children}
        </Menu>
      )}
    </Item>
  );
};

Object.assign(Bs5Dropdown, {
  Menu,
  Divider,
  Item,
  SubMenu,
  ContextMenu
});

export default Bs5Dropdown;
